export const LEGACY_LAST_CONNECTED_WALLETS = 'last-connected-wallets';
export const HUB_LAST_CONNECTED_WALLETS = 'hub-v1-last-connected-wallets';
